// A paragraph of his Word draft as the editor reads and writes it: stretches
// of text, each bold, italic or underlined or not. Tabs and line breaks are
// "\t" and "\n" in the text.
export type ParagraphRun = {
  text: string;
  bold: boolean;
  italic: boolean;
  underline: boolean;
};

const sameFormat = (a: ParagraphRun, b: ParagraphRun) =>
  a.bold === b.bold && a.italic === b.italic && a.underline === b.underline;

// Joins neighbouring pieces in the same format, and drops empty ones.
export const mergeRuns = (pieces: ReadonlyArray<ParagraphRun>) =>
  pieces.reduce<ParagraphRun[]>((runs, piece) => {
    if (piece.text === "") return runs;
    const last = runs.at(-1);
    if (last && sameFormat(last, piece)) {
      runs[runs.length - 1] = { ...last, text: last.text + piece.text };
      return runs;
    }
    runs.push({ ...piece });
    return runs;
  }, []);

// A run's text in the pieces the editor makes nodes of: tabs and line
// breaks on their own.
export const splitRunText = (text: string) =>
  text.split(/(\t|\n)/).filter((part) => part !== "");

// His paragraph reads the same after his edit, format and all: nothing to save.
export const sameRuns = (
  before: ReadonlyArray<ParagraphRun>,
  after: ReadonlyArray<ParagraphRun>,
) => {
  const [a, b] = [mergeRuns(before), mergeRuns(after)];
  return (
    a.length === b.length &&
    a.every((run, index) => {
      const other = b[index];
      return (
        other !== undefined && run.text === other.text && sameFormat(run, other)
      );
    })
  );
};
